import AppDialog from '../../components/app_dialog'
import { TextField } from '@cinesend/ui-kit'
import { useState } from 'react'
import useStore from '../../hooks/use_store'
import { useQueryClient } from '@tanstack/react-query'

const CreateCycleModal = ({ airlineID, closeModal }) => {
  const { createModel } = useStore()
  const [name, setName] = useState('')
  const queryClient = useQueryClient()

  const createCycle = () => {
    createModel.mutate(
      { endpoint: 'cycles', data: { airline_id: airlineID, name } },
      {
        onSuccess: (res) => {
          setName('')
          closeModal()
          queryClient.invalidateQueries([`cycles?airlineID=${airlineID}`])
        },
      }
    )
  }

  return (
    <AppDialog title='Create cycle' onClose={() => closeModal()} confirmText='Create' onConfirm={() => createCycle()}>
      <TextField
        label={`Name`}
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyPress={(e) => e.charCode === 13 && !!e.target.value && createCycle()}
        placeholder={`Enter new name here...`}
        autoFocus
      />
    </AppDialog>
  )
}

export default CreateCycleModal
